import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { SuggestionFilter, noMatchingFilter, allMatchingFilter } from './suggestion-filter';
import { Suggestion } from './suggestion';
import { takeUntil } from 'rxjs/operators';

export class SuggestionDataSource {
    private suggestionList: Suggestion[]; //  = [];
    private filteredSuggestionList: Suggestion[] = [];
    private filter: SuggestionFilter; //  = allMatchingFilter;
    private unsubscribe$ = new Subject<void>();
    $filteredSuggestions: BehaviorSubject<Suggestion[]>;

    constructor(suggestionStream: Observable<Suggestion[]>, filterStream: Observable<SuggestionFilter>) {
        this.$filteredSuggestions = new BehaviorSubject(this.filteredSuggestionList);
        /* se cambia il filtro o la lista dei suggerimenti emetto un evento di nuova lista filtrata */
        suggestionStream.pipe(takeUntil(this.unsubscribe$)).subscribe(
            newSuggestionList => {
                this.suggestionList = newSuggestionList;
                if (this.suggestionList) {
                    this.filteredSuggestionList = this.suggestionList.filter(s => this.isSuggestionCompliantWithFilter(s));
                    this.$filteredSuggestions.next(this.filteredSuggestionList);
                }
            }
        );
        filterStream.pipe(takeUntil(this.unsubscribe$)).subscribe(
            newFilter => {
                this.filter = newFilter;
                if (this.suggestionList) {
                    this.filteredSuggestionList = this.suggestionList.filter(s => this.isSuggestionCompliantWithFilter(s));
                    this.$filteredSuggestions.next(this.filteredSuggestionList);
                }
            }
        );
    }

    public getSuggestion(index: number): Suggestion {
        let result: Suggestion = null;
        if (this.isSuggestionIndexValid(index)) {
            result = this.suggestionList[index];
        }
        return result;
    }

    private isSuggestionIndexValid(suggestionIndex: number) {
        return this.suggestionList && suggestionIndex < this.suggestionList.length;
    }

    public getFilter(): SuggestionFilter {
        return this.filter;
    }

    private isSuggestionCompliantWithFilter(s: Suggestion) {
        if (!this.filter || this.filter === noMatchingFilter) {
            return false;
        } else if (this.filter === allMatchingFilter) {
            return true;
        } else {
            const filterCode = this.filter.code ? this.filter.code.toLowerCase() : null;
            const filterText = this.filter.text ? this.filter.text.toLowerCase() : null;
            const sCode = s.code ? s.code.toLowerCase() : null;
            const sText = s.Description ? s.Description.toLowerCase() : null;
            if ((filterCode && sCode && sCode.startsWith(filterCode)) || (filterText && sText && sText.startsWith(filterText))) {
                return true;
            }
        }
        return false;
    }

    public close() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
